/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const OLMo = ({ color = 'primary', aspectRatio = '659/133', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="OLMo" aspectRatio={aspectRatio} color={color} {...rest} />;

export { OLMo, OLMo as default };
